import React,{useEffect,useState} from "react";
import ndm from "./NotificationDetails.module.css"
import styled from '@emotion/styled'
import {formatPrice} from '../../../../helpers/Helper'
import { set } from "numeral";
import { isUndefined } from "lodash";
import { getResourceFile,adminToken, editNotifications } from '../../../../network';

const OrderWrapper = styled.div`
    position: relative;
    top: 12rem;

    .subtotal{
        display: flex;
        justify-content: flex-end;
        padding-right: var(--space-24);
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-16);
        line-height: var(--space-18);
        color: var(--company-dark);
    }

    
  
    

`;

const OrderContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 30rem;
    min-width: 10rem;
    padding: var(--space-24) var(--space-24) var(--space-40) var(--space-2);


    .details {
        display: flex;
        flex-direction: column;

        > .qty{
       color: var(--color-gray-500);
       font-size: var(--font-14);
       font-family: Inter,sans-serif;
   }
        
        > span {
            font-family: Inter,sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: var(--font-16);
            line-height: var(--font-18);
            
            color: var(--color-gray-900);
            
            margin-bottom: var(--space-8);
            
            > b {
                font-weight: 600;
            }
        }
        
        > span.price {
            font-style: normal;
            font-weight: 500;
            font-size: var(--font-16);
            line-height: var(--font-14);
            
            text-align: right;
            
            color: var(--company);
        }
        
        > span.quantity {
            font-style: normal;
            font-weight: 500;
            font-size: var(--font-12);
            line-height: var(--font-12);
            
            text-align: right;
            
            color: var(--color-gray-600);
        }
    }
    
    .configuration {
        order: 1;
    }
    
    .pricing {
        order: 2
    }
    
    .buttons {
        display: flex;
        flex-direction: row;
        
        justify-content: flex-end;
        
        button {
            border: none;
            box-shadow: none;
            background: none;
            padding: 0;
            
            margin-left: var(--space-24);
            
            color: var(--color-gray-700);
            
            font-style: normal;
            font-size: var(--font-14);
            line-height: var(--font-14);
            font-weight: 500;
        }
        
        &:first-of-type {
            margin-left: 0;
        }
        
        button.repeat {
            color: var(--company-dark);
        }
        
        button.cancel {
            color: var(--color-red-700);
        }
    }
 
    @media (max-width:500px){
      
    }
    @media (max-width: 400px){
   
    }
`;

const OrderLineItem = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: var(--space-64) auto;
    grid-gap: 1rem;
    
    width: auto;
    
    padding-bottom: var(--space-24);
    margin-bottom: var(--space-16);
    
    border-bottom: 1px solid var(--color-gray-300);
   
`;

const ProductImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    width: var(--space-64);
    height: var(--space-64);

    background: white;

    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: var(--space-8);
    
    > .badge {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        
        width: auto;
        height: var(--space-18);
        min-width: var(--space-18);
        
        font-size: var(--font-12);
        line-height: var(--font-12);
        
        background: white;
        border: 1px solid var(--color-gray-500);
        box-sizing: border-box;
        box-shadow: none;
        
        border-radius: 0.625rem;
        left: 3.25rem;
        top: 3.25rem;
        margin: 0;
    }
    
    > img {
        width: 90%;
        height: 90%;
        object-fit: contain;
        padding: 0.25rem;
    }
`;




function NotificationDetails(props) {

    const [orders,setOrders] = useState(false)
    const [values, setValues] = useState([]);
    let num = 0;

    // const showOrders = (id) => {
    //     getOrders(adminToken,id)
    //         .then(result => {
    //             setValues(result);
                
    //         })
    //         .catch(error => console.error(error));
       
    // };

    const editFlagged = (id,value) => {
        editNotifications(adminToken,id,value);
        window.location.reload(false)
    }

    const markAsRead = (id,value) => {
        editNotifications(adminToken,id,value);
        window.location.reload(false)
    }
    const markAsArchived= (id,value) => {
        editNotifications(adminToken,id,value);
        window.location.reload(false)
    }

    useEffect(()=> {

        if(!isUndefined(props.order.variants)){

           try {
            
            //props.order.variants.map((val) => {setValues([val]); });
            setValues(props.order.variants);
            console.log(props.order.variants);
           } catch (error) {
               console.error(error);
           }
            
        }

    },[props.order]);

    const checkType = (type) => {
        if(type === 'order'){
            return "New Order Received";
           
        } else if(type === 'contact'){
            return "Customer Message Received";
        }
    }

    const checkIcon = (type) => {
        if(type === 'order'){
            return "/icons/ellipse_purple.svg";
           
        } else if(type === 'contact'){
            return "/icons/ellipse_green.svg";
        }
    }

    const checkFlagged = (flag) => {
        if(flag){
            return "/icons/flagged.svg";
           
        } 
    }

    const getName = (type) =>{
        if(type === 'contact'){
            return props.info.contact.name

        }else if(type === 'order'){
            return props.info.customer.first_name+" "+props.info.customer.last_name || '';
        }
    }

    const convertDate = (date) =>{
            return new Date(props.info.created).toDateString() || '';
    }

    return (
   
    
        <div style={{display:"flex",width:"10rem"}}>
            <div className={ndm.orderhead}>
                <span id={ndm.or}>{checkType(props.info.type) || ''}</span>
                <img id={ndm.flag} src={checkFlagged(props.info.flagged)}></img>
                <img id={ndm.ellipse} src={checkIcon(props.info.type)}></img>
                <span id={ndm.fr}>{`Fr: ${getName(props.info.type)}` || ''}</span>
                <span id={ndm.dt}>{convertDate(props.info.created) || ''}</span>
            </div>
            <p id={ndm.para}>
               {props.info.notification_content}
            </p>
            {/* <img id={ndm.ph} src="/icons/rectangleph.png"></img> */}
        <>

       {props.info.type === 'order' &&
           <OrderWrapper>
            {values.map((order,index) =>
                
                      
                <OrderContainer key={index}>                                           
                    <OrderLineItem>
                        <ProductImageContainer>
                            <img src={getResourceFile(order.variant.product.media[0].resource)}/>
                            <div className="badge">{order.quantity}</div>
                        </ProductImageContainer>
                        <div className="details configuration">
                            <span>{order.variant.product.name+" "+order.variant.attribute+","+order.variant.size}</span>
                            <span className="qty">Qty: {order.quantity}</span>
                        </div>
                        <div className="details pricing">
                            <span className="price">{formatPrice(order.originalPrice)}</span>
                        
                        </div>
                    </OrderLineItem>
                </OrderContainer>
                       
            
            )}
            <span className="subtotal">Order Total ({props.order.totalQuantity+" "}items):{formatPrice(props.order.cartTotal)}</span>
    </OrderWrapper>
        }
        </>
            <div className={ndm.column}>
                <div className={ndm.baseline}></div>
                <div className={ndm.actions}>
                    <button onClick={()=> editFlagged(props.info.id,{"flagged":true})} style={{color:"var(--color-red-400)"}}>Flag</button>
                    <button onClick={()=> markAsRead(props.info.id,{"read":false})} style={{color:"var(--company)",marginRight:"9rem"}}>Mark as Unread</button>
                    <button onClick={()=> markAsArchived(props.info.id,{"archived":true})} style={{color:"var(--color-gray-800)"}}>Archive</button>
                </div>
            </div>

        </div>

    )
}

export default NotificationDetails;